// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"e081d4be","185":"a587e217","197":"13b9bf1a","725":"f7286508","759":"83fb210d","897":"67797c3e"}[chunkId] + ".chunk.js";
};